import { SelectMasterTranslator } from 'src/translators'
import { BulkUpdateSelectMasterFormEntity } from 'src/types'
import {
  useBulkUpdateSelectMastersMutation,
  useCopySelectMasterMutation,
} from 'src/types/generated'

type BulkUpdateSelectMastersInput = {
  projectId: string
  formEntity: BulkUpdateSelectMasterFormEntity
}

type CopySelectMastersOutput = {
  projectId: string
  selectMasterId: string
}

export const useSelectMaster = () => {
  const [bulkUpdateSelectMastersMutation] = useBulkUpdateSelectMastersMutation()
  const [copySelectMasterMutation] = useCopySelectMasterMutation()

  const bulkUpdateSelectMasters = async (input: BulkUpdateSelectMastersInput) => {
    const { projectId, formEntity } = input
    const params = SelectMasterTranslator.toRequest(formEntity)
    await bulkUpdateSelectMastersMutation({ variables: { projectId, params } })
  }

  const copySelectMaster = async ({ projectId, selectMasterId }: CopySelectMastersOutput) => {
    await copySelectMasterMutation({
      variables: { projectId, selectMasterId: Number(selectMasterId) },
    })
  }

  return {
    bulkUpdateSelectMasters,
    copySelectMaster,
  }
}
